
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class MutantBadge extends Vue {
  @Prop({ default: 'grey' })
    color: string;
}
